import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from '@lubehub/theme';
/**
 * The props that make one element arrive: a fade and a short rise, staggered
 * by its position. For elements that cannot take a wrapper — a table row, a
 * grid cell — spread them onto the element itself.
 *
 * It is a CSS animation, so it runs once when the element is inserted and
 * never again on a re-render. Only the first `motion.entrance.limit` items
 * animate; the rest are already in place. `prefers-reduced-motion` removes it.
 */
export function entrance({ index = 0, disabled = false } = {}) {
    if (disabled || index >= motion.entrance.limit) {
        return {};
    }
    return {
        className: 'lh-enter',
        style: { '--enter-index': String(index) },
    };
}
/** `<Entrance index={i}><Card /></Entrance>` — the same arrival as a wrapper. */
export function Entrance({ children, className, ...options }) {
    const props = entrance(options);
    return (_jsx("div", { className: [props.className, className].filter(Boolean).join(' ') || undefined, style: props.style, children: children }));
}
//# sourceMappingURL=Entrance.js.map